module.exports = __webpack_public_path__ + "static/media/MainBarMobile.327e524d.png";